/**
 * Wake the sender (Edge Function `email-worker`, which sends email and push)
 * right after something that queues one reaches the server, so OP-201s, pickup sheets and reports
 * leave in seconds instead of waiting for the database's 2-minute check.
 * Fire-and-forget: if it isn't deployed or there's no signal, the database
 * job sends it later.
 */
import { supabase } from './supabase';

/**
 * Tables whose changes queue an email or a push (migrations 0022, 0023, 0035,
 * 0036): driver forms, and the manager changes drivers get a push about —
 * time-off decisions, work orders (the driver's report follows the job),
 * uniform statuses, messages.
 */
export const EMAIL_TABLES = new Set(['op201_forms', 'bulk_pickups', 'accident_reports', 'maintenance_requests', 'timeoff_requests', 'uniform_requests', 'work_orders', 'broadcasts']);

let timer: ReturnType<typeof setTimeout> | null = null;

export function kickEmail(delayMs = 1500): void {
  if (!supabase) return;
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    timer = null;
    void supabase!.functions.invoke('email-worker', { body: {} }).catch(() => undefined);
  }, delayMs);
}

export function onPushedKick(table: string, op: string): void {
  if (op === 'upsert' && EMAIL_TABLES.has(table)) kickEmail();
}
